// Network tab — leaf under SiteLayout. Site router + firewall editors over the
// site_network/site_firewall APIs.

import { createFileRoute } from "@tanstack/react-router";

import { SiteNetworkPanel } from "../features/siteNetwork/SiteNetworkPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/network",
)({
  component: NetworkRoute,
});

function NetworkRoute() {
  const { accountSlug, siteSlug } = Route.useParams();
  return <SiteNetworkPanel accountSlug={accountSlug} siteSlug={siteSlug} />;
}
